import React from "react";
import PropTypes from "prop-types";
import { Col, Form, Row } from "react-bootstrap";
import { FormattedDate, FormattedMessage } from "react-intl";

/**
 * Invoer voor een jaarlijks terugkerende dag en maand, bewaard als 'MM-DD'.
 * Een oude waarde in het formaat 'YYYY-MM-DD' wordt omgezet naar 'MM-DD'.
 */
class MonthDayInputComponent extends React.Component {

    // Geen schrikkeljaar: 29 februari is niet selecteerbaar
    static daysInMonth = (month) => new Date(2023, month, 0).getDate();

    static parse = (value) => {
        const match = /^(?:\d{4}-)?(\d{2})-(\d{2})$/.exec(value || '');
        return match ? { month: parseInt(match[1], 10), day: parseInt(match[2], 10) } : { month: '', day: '' };
    };

    constructor(props) {
        super(props);

        this.state = MonthDayInputComponent.parse(this.props.value);
    }

    componentDidMount() {
        // Oude waarde (YYYY-MM-DD) meteen normaliseren naar MM-DD
        if (this.props.value && this.props.value.length > 5 && this.state.month && this.state.day) {
            this.props.onChange(this.format(this.state.month, this.state.day));
        }
    }

    format = (month, day) => String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');

    onChange = (field, value) => {
        let { month, day } = { ...this.state, [field]: value ? parseInt(value, 10) : '' };

        if (month && day && day > MonthDayInputComponent.daysInMonth(month)) {
            day = '';
        }

        this.setState({ month, day }, () => {
            this.props.onChange(month && day ? this.format(month, day) : '');
        });
    };

    render() {
        const days = Array.from({ length: this.state.month ? MonthDayInputComponent.daysInMonth(this.state.month) : 31 }, (_, i) => i + 1);
        const months = Array.from({ length: 12 }, (_, i) => i + 1);

        return (
            <Row>
                <Col xs={4}>
                    <Form.Control as="select" name={this.props.name + '_day'} value={this.state.day}
                        isInvalid={this.props.isInvalid}
                        onChange={event => this.onChange('day', event.target.value)}>
                        <FormattedMessage id="CMS.Form.month_day.day">
                            {value => <option value="">{value}</option>}
                        </FormattedMessage>
                        {days.map(day => <option key={day} value={day}>{day}</option>)}
                    </Form.Control>
                </Col>
                <Col xs={8}>
                    <Form.Control as="select" name={this.props.name + '_month'} value={this.state.month}
                        isInvalid={this.props.isInvalid}
                        onChange={event => this.onChange('month', event.target.value)}>
                        <FormattedMessage id="CMS.Form.month_day.month">
                            {value => <option value="">{value}</option>}
                        </FormattedMessage>
                        {months.map(month => (
                            <FormattedDate key={month} value={new Date(2023, month - 1, 1)} month="long">
                                {value => <option value={month}>{value}</option>}
                            </FormattedDate>
                        ))}
                    </Form.Control>
                </Col>
            </Row>
        );
    }
}

MonthDayInputComponent.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isInvalid: PropTypes.bool
};

export default MonthDayInputComponent;
